import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function InsertRowAfterIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 24, 24);
  const a11y = resolveA11yProps(props);

  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={width}
      height={height}
      {...rest}
      {...a11y}
    >
      {title ? <title>{title}</title> : null}
      <path
        fillRule="nonzero"
        fill="currentColor"
        d="M12 13c.5 0 1 .4 1 .9V16h2a1 1 0 0 1 .1 2H13v2a1 1 0 0 1-2 .1V18H9a1 1 0 0 1-.1-2H11v-2c0-.6.4-1 1-1zm6 7a1 1 0 0 1 0-2h1v-6H5v6h1a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1V6c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v13c0 .5-.4 1-.9 1H18zM11 6H5v4h6V6zm8 0h-6v4h6V6z"
      />
    </svg>
  );
}

export default InsertRowAfterIcon;

